export default __webpack_public_path__ + "static/media/close.8b3f8087.svg";